export const menu = {
	header: {
		search: "Buscar menús",
		create: "Crear Menú",
		manualMode: "Modo Manual",
	},
	menuList: "Menú para delivery",
	menuCard: {
		message: "funcionamiento 24h",
		at: "a las",
		delivery: "Delivery",
		table: "Pedido en mesa",
		integratedDelivery: "Delivery Integrado",
		businessHour: "Horario de funcionamiento",
		type: "Tipo",
		active: "activo",
		inactive: "inactivo",
	},
	noMenu: {
		title: "Menú para delivery",
		message: "Parece que aún no tiene ningún menú creado",
		create: "Crear Menú",
	},
	warningNotification:
		"Menú creado, pero hubo un problema en el registro del horario de funcionamiento:",
};
